import TawkMessengerVue from "@tawk.to/tawk-messenger-vue-2";
import VueMeta from "vue-meta";

import Vue from "vue";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import axios from "axios";
import VModal from "vue-js-modal";
import VueRouter from "vue-router";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faGoogle,
  faTwitter,
  faWhmcs,
  faFacebookF,
} from "@fortawesome/free-brands-svg-icons";

import {
  faAngleDown,
  faAngleUp,
  faAngleRight,
  faCaretRight,
  faBell,
  faTimes,
  faPlus,
  faCalendarAlt,
  faLock,
  faClock,
  faPlusCircle,
  faExclamationCircle,
  faBullhorn,
  faTimesCircle,
  faEdit,
  faCalendar,
  faTrashAlt,
  faSortAmountDownAlt,
  faMobileAlt,
  faCheck,
  faPaperPlane,
  faPaperclip,
  faEllipsisV,
  faGlobe,
  faUsers,
  faCommentDots,
  faBalanceScale,
  faFileAlt,
  faWallet,
  faIdCard,
  faPeopleCarry,
  faFax,
  faMoneyBillWave,
  faHandHoldingHeart,
  faPoll,
  faCogs,
  faPhoneAlt,
  faUser,
  faQuestion,
  faExclamationTriangle,
  faBars,
  faCheckCircle,
  faLongArrowAltRight,
  faDownload,
  faUpload,
  faHeart,
  faHistory,
  faPlay,
  faFile,
  faSpinner,
  faCalendarCheck,
  faFileInvoice,
  faChevronCircleRight,
  faBed,
  faBriefcase,
  faSearch,
  faListAlt,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import App from "./App.vue";
import { routes } from "./routes/route";
import { store } from "./store/store";

library.add(
  faAngleDown,
  faBell,
  faAngleUp,
  faCaretRight,
  faTimes,
  faPlus,
  faAngleRight,
  faCalendarAlt,
  faLock,
  faGoogle,
  faTwitter,
  faClock,
  faPlusCircle,
  faExclamationCircle,
  faBullhorn,
  faTimesCircle,
  faEdit,
  faCalendar,
  faTrashAlt,
  faSortAmountDownAlt,
  faMobileAlt,
  faCheck,
  faPaperPlane,
  faPaperclip,
  faEllipsisV,
  faGlobe,
  faUsers,
  faCommentDots,
  faBalanceScale,
  faFileAlt,
  faWallet,
  faIdCard,
  faPeopleCarry,
  faFax,
  faMoneyBillWave,
  faHandHoldingHeart,
  faPoll,
  faWhmcs,
  faCogs,
  faPhoneAlt,
  faUser,
  faQuestion,
  faExclamationTriangle,
  faBars,
  faCheckCircle,
  faLongArrowAltRight,
  faDownload,
  faUpload,
  faHeart,
  faHistory,
  faPlay,
  faFile,
  faSpinner,
  faCalendarCheck,
  faFileInvoice,
  faChevronCircleRight,
  faBed,
  faBriefcase,
  faSearch,
  faListAlt,
  faMapMarkerAlt,
  faFacebookF
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.config.productionTip = false;
Vue.use(VueRouter);

Vue.use(VueMeta);

Vue.use(TawkMessengerVue, {
  propertyId: "property_id",
  widgetId: "widget_id",
});

Vue.use(Toast);

Vue.use(VModal);

Vue.prototype.$http = axios;
const token = sessionStorage.getItem("userToken");
if (token) {
  Vue.prototype.$http.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${token}`;
} else {
  axios.defaults.headers.common["Authorization"] = null;
}

Vue.prototype.$http.defaults.headers.common["Content-Type"] =
  "application/json";

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
    return { x: 0, y: 0 };
  },
});

export const eventBus = new Vue();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
